import { defineStore } from "pinia";
import { ref } from "vue";

import { getTimeFromSeconds } from "shared/helpers/date";
import OrganisationsService from "shared/services/api/OrganisationsService";
import useUserStore from "shared/stores/user";
import { type Maybe, type Nullable } from "shared/types";

import {
  type MentionToOrganisationReport,
  type OrganisationReportSpec,
} from "./types";

export const useDesktopStore = defineStore("desktop", () => {
  const isDraggingOrganisationReportMention = ref<boolean>(false);
  const organisationReportSpecsOpen = ref<boolean>(false);
  const organisationReportSpec = ref<Nullable<OrganisationReportSpec>>(null);
  const organisationReportSpecs = ref<Nullable<OrganisationReportSpec[]>>(null);

  const addedOrganisationReportMention =
    ref<Nullable<MentionToOrganisationReport>>(null);

  function getOrganisationReportSpec() {
    return OrganisationsService.reportSpecs<OrganisationReportSpec>(
      useUserStore().currentUser.organisation.id
    ).then((response) => {
      organisationReportSpecs.value = response.data;
    });
  }

  function showOrganisationReportSpecs(value: boolean) {
    organisationReportSpecsOpen.value = value;
  }

  function setOrganisationReportSpec(spec: Maybe<OrganisationReportSpec>) {
    if (spec) {
      Object.assign(spec, {
        scheduled_delivery_time: getTimeFromSeconds(spec.delivery_time),
      });

      organisationReportSpec.value = spec;
    }
  }

  function addMentionToOrganisationReport(
    value: Nullable<MentionToOrganisationReport>
  ) {
    addedOrganisationReportMention.value = value;
  }

  return {
    addedOrganisationReportMention,
    addMentionToOrganisationReport,
    getOrganisationReportSpec,
    isDraggingOrganisationReportMention,
    organisationReportSpec,
    organisationReportSpecs,
    organisationReportSpecsOpen,
    setOrganisationReportSpec,
    showOrganisationReportSpecs,
  };
});

export default useDesktopStore;
